import api from "./api";
import {
  classifyVerificationError,
  type VerificationError,
} from "./verificationErrors";
import { gvmBouncerPath, gvmPath } from "./apiPaths";

export { isValidIfscFormat, isPlausibleAccountNumber } from "./validators";

const ENDPOINT_NAME = "/verify-bank";

export type BankVerifyInput = {
  account_number: string;
  ifsc: string;
};

export type BankVerifyResult = {
  valid: boolean;
  nameAtBank: string | null;
  message: string | null;
};

export type BankVerifyError = VerificationError;

export type BankVerifyAuthMode = "vendor" | "bouncer";

export async function verifyBank(
  input: BankVerifyInput,
  opts: { auth?: BankVerifyAuthMode } = {},
): Promise<BankVerifyResult> {
  const auth = opts.auth ?? "vendor";
  const url =
    auth === "vendor" ? gvmPath(ENDPOINT_NAME) : gvmBouncerPath(ENDPOINT_NAME);
  const config = auth === "vendor" ? { useVendorToken: true } : {};
  const res = (await api.post(url, input, config)) as
    | { valid?: boolean; name_at_bank?: string; message?: string }
    | null;
  return {
    valid: Boolean(res?.valid),
    nameAtBank: typeof res?.name_at_bank === "string" ? res.name_at_bank : null,
    message: typeof res?.message === "string" ? res.message : null,
  };
}

export function classifyBankVerifyError(err: unknown): BankVerifyError {
  return classifyVerificationError(err, "bank");
}
